import React, { useState, useEffect, useRef } from 'react';
import '../css/Chatbot.css';

const Chatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    { text: "Hello! I'm your CDL assistant. How can I help you today?", sender: "bot", time: "Just now" }
  ]);
  const [inputValue, setInputValue] = useState("");
  const messagesEndRef = useRef(null);

  const knowledgeBase = {
    "hello": "Hello! How can I assist you with Colombo Dockyard today?",
    "hi": "Hi there! What would you like to know about our services?",
    "services": "We specialize in shipbuilding, repairs, conversions, and offshore engineering services.",
    "contact": "You can reach us at:\n📞 +94 112 429 000\n📧 info@cdl.lk",
    "location": "Our shipyard is at No. 153, Church Street, Colombo 01, Sri Lanka",
    "jobs": "Check our Careers page or email hr@cdl.lk with your CV",
    "thanks": "You're welcome! Is there anything else I can help with?",
    "bye": "Thank you for contacting Colombo Dockyard. Have a great day!"
  };

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleSend = () => {
    if (!inputValue.trim()) return;

    const userMessage = { text: inputValue, sender: "user", time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) };
    setMessages(prev => [...prev, userMessage]);
    setInputValue("");

    // Simulate bot response
    setTimeout(() => {
      const botResponse = getBotResponse(inputValue);
      setMessages(prev => [...prev, { text: botResponse, sender: "bot", time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }]);
    }, 1000);
  };

  const getBotResponse = (text) => {
    const lowerText = text.toLowerCase();
    for (const key in knowledgeBase) {
      if (lowerText.includes(key)) return knowledgeBase[key];
    }
    return "I'm still learning about Colombo Dockyard's services. For detailed inquiries, please contact us at info@cdl.lk.";
  };

  return (
    <div id="modern-chatbot">
      {isOpen && (
        <div className="chatbot-window active">
          <div className="chatbot-header">
            <div className="chatbot-avatar">
              <img src="/wp-content/uploads/logo.png" alt="CDL Chat Assistant" width="40" height="40" />
            </div>
            <div className="chatbot-title">
              <h3>Colombo Dockyard PLC</h3>
              <p id="current-status">Online • Typically replies in 30s</p>
            </div>
            <button className="chatbot-close" onClick={() => setIsOpen(false)}>✕</button>
          </div>
          
          <div className="chatbot-messages">
            {messages.map((msg, index) => (
              <div key={index} className={`message-${msg.sender}`}>
                {msg.sender === 'bot' && (
                  <div className="message-avatar">
                    <img src="/wp-content/uploads/logo.png" alt="CDL Assistant" width="32" height="32" />
                  </div>
                )}
                <div className="message-content">
                  <div className="message-text">{msg.text}</div>
                  <div className="message-footer">
                    <span className="message-time">{msg.time}</span>
                  </div>
                </div>
              </div>
            ))}
            <div ref={messagesEndRef} />
          </div>
          
          <div className="chatbot-input-area">
            <input 
              type="text" 
              placeholder="Type your message..." 
              className="chatbot-input"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleSend()}
            />
            <button className="chatbot-send" onClick={handleSend}>➤</button>
          </div>
        </div>
      )}
      
      <button className="chatbot-trigger" onClick={() => setIsOpen(!isOpen)}>
        <span style={{ color: 'white', fontSize: '24px' }}>💬</span>
      </button>
    </div>
  );
};

export default Chatbot;
